module.exports = __webpack_public_path__ + "img/MoraniCenterLogo_horizontal.8948556d.png";